
<a [href]="appItem.url" target="_blank">
<div class="applicationsWrapper shadow" >
    <div class="icon">
        
        <img src="assets/theme/mclane/img/{{appItem.image}}.png" (error)="onImgError($event)"></div>
    <div class="applicationName">
        {{appItem.text}}
    </div>
    <div class="hintOfColor"></div>
</div>
</a>
